import React, { useEffect, useRef } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "./Models.css";
import { MessageType } from "../../../../Helper";
import GenerateImageIcon from "../../../../Custom-imeges/GenerateImageIcon";
import { useAppSelector } from "../../../../store/hooks";

interface Props {
  modelName: string;
  messageType?: number;
}

const ResponseLoading = ({ modelName, messageType }: Props) => {
  const chatNum = useAppSelector((s) => s.ChatsState.chatsNum);
  const scrollDevRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollDevRef.current) {
      scrollDevRef.current?.scrollIntoView({
        behavior: 'smooth', 
        block: 'start',
      });
  }
  }, []);

  function capitalizeWords() {
    return modelName?.replace(/ai/gi, "Ai")?.replace(/gpt/gi, "GPT");
  }

  return (
    <div ref={scrollDevRef}>
      <div
        className={`chatResponseLoading position-relative mb-3 ${messageType === MessageType.MessageHasImage && 'generation-loading'}`}
      >
        <div
          id="chat-details"
          className=" d-flex align-items-center justify-content-between"
        >
          <div
            className={`d-flex align-items-center mb-1 justify-content-center gap-2`}
          >
            <img className={`${modelName}Logo`} />
            <p className="chatName mb-0">{capitalizeWords()}</p>
          </div>
        </div>
        {messageType === MessageType.MessageHasImage&&(modelName?.toLowerCase()==="chatgpt"||modelName.toLowerCase()==="gemini") ? (
          <div
            className={`loader-wrapper d-flex justify-content-center align-items-center box-loading image-generation ${
              chatNum === 4 || chatNum === 6 ? "small-size" : "large-size"
            }`}
          >
            <CircularProgress
              className="image-loader"
              size="60px"
              value={100}
              thickness={1}
            />
            <div className="loader-content">
              <GenerateImageIcon className="custom-icon-color" />
              <div className="image-generate-word">Generate</div>
            </div>
          </div>
        ) : (
          <div
            className="response position-relative w-100 d-flex align-items-center "
            style={{ height: "60px" }}
          >
            <div className="loading d-flex gap-1 mt-2">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResponseLoading;
